<script lang="ts">
  import moment from "moment"
  import countdown from "countdown"
  import { onDestroy, onMount } from 'svelte'

  let {
    datetime,
    className = "",
    showDays = true,
    showHours = true,
    showMinutes = true,
    showSeconds = true
  } = $props()

  let values = $state({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  })
  let interval = $state(null)
  let classNames = $derived(`flex-row ${className}`)

  onMount(() => {
    updateCounter()
    interval = window.setInterval(updateCounter, 1000)
  })

  onDestroy(() => {
    window.clearInterval(interval)
  })

  function updateCounter() {
    if (datetime) {
      let v = values
      let now = moment()
      let target = moment(new Date(datetime))

      if (target < now) {
        v.days = 0
        v.hours = 0
        v.minutes = 0
        v.seconds = 0
        return
      }

      let units = countdown.DAYS |
        countdown.HOURS |
        countdown.MINUTES |
        countdown.SECONDS
      let new_values = countdown(null, target, units)
      v.days = new_values.days
      v.hours = new_values.hours
      v.minutes = new_values.minutes
      v.seconds = new_values.seconds
    }
  }
</script>

<div class={classNames}>
  <div class:d-none={!showDays} class="cell-1 days">{values.days}</div>
  <div class:d-none={!showHours} class="cell-1 hours">{values.hours}</div>
  <div class:d-none={!showMinutes} class="cell-1 minutes">{values.minutes}</div>
  <div class:d-none={!showSeconds} class="cell-1 seconds">{values.seconds}</div>
</div>
